import { render, staticRenderFns } from "./mdi-view-dashboard.vue?vue&type=template&id=4035d8d2&"
import script from "./mdi-view-dashboard.vue?vue&type=script&lang=js&"
export * from "./mdi-view-dashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4035d8d2')) {
      api.createRecord('4035d8d2', component.options)
    } else {
      api.reload('4035d8d2', component.options)
    }
    module.hot.accept("./mdi-view-dashboard.vue?vue&type=template&id=4035d8d2&", function () {
      api.rerender('4035d8d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/mdi-view-dashboard.vue"
export default component.exports